import LineTextLabel from './LineTextLabel';

export default LineTextLabel;
